const canUseDOM = typeof document !== "undefined";

// eslint-disable-next-line import/no-mutable-exports
let serverNextConfig = {};

if (!canUseDOM) {
  const config = global.PR_SERVER_NEXT_CONFIG || global.SERVER_NEXT_CONFIG;

  if (config) {
    serverNextConfig = config;
  }
}

export default serverNextConfig;
